"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/Header/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _LinkBar = require('web/components/VideoRooms/Room/LinkBar'); var _LinkBar2 = _interopRequireDefault(_LinkBar);
var _DesktopMoreTooltip = require('./DesktopMoreTooltip'); var _DesktopMoreTooltip2 = _interopRequireDefault(_DesktopMoreTooltip);
var _MenuPicker = require('web/components/VideoRooms/Room/MenuPicker');
var _RenameRoomModal = require('./RenameRoomModal'); var _RenameRoomModal2 = _interopRequireDefault(_RenameRoomModal);
var _ArchiveRoomModal = require('./ArchiveRoomModal'); var _ArchiveRoomModal2 = _interopRequireDefault(_ArchiveRoomModal);
var _Modal = require('web/screens/VideoRooms/History/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
















const RoomBodyHeader = ({
  onBack,
  gotoMeeting,
  onRoomShare,
  onRoomLinkCopy,
  roomName,
  roomLink,
  activeParticipantsCount,
  isRoomArchived,
  onRoomRename,
  onRoomArchive,
  onRoomUnarchive,
}) => {
  const [isMobileMoreMenuOpen, setIsMobileMoreMenuOpen] = _react.useState.call(void 0, false)
  const [isRenameRoomModalOpen, setIsRenameRoomModalOpen] = _react.useState.call(void 0, false)
  const [isArchiveRoomModalOpen, setIsArchiveRoomModalOpen] = _react.useState.call(void 0, false)
  const [isDesktopHistoryModalOpen, setIsDesktopHistoryModalOpen] = _react.useState.call(void 0, false)
  const [isMobileHistoryModalOpen, setIsMobileHistoryModalOpen] = _react.useState.call(void 0, false)

  const openMobileMoreMenu = _react.useCallback.call(void 0, () => setIsMobileMoreMenuOpen(true), [])
  const closeMobileMoreMenu = _react.useCallback.call(void 0, () => setIsMobileMoreMenuOpen(false), [])
  const openRenameRoomModal = _react.useCallback.call(void 0, () => setIsRenameRoomModalOpen(true), [])
  const closeRenameRoomModal = _react.useCallback.call(void 0, () => setIsRenameRoomModalOpen(false), [])
  const openArchiveRoomModal = _react.useCallback.call(void 0, () => setIsArchiveRoomModalOpen(true), [])
  const closeArchiveRoomModal = _react.useCallback.call(void 0, () => setIsArchiveRoomModalOpen(false), [])
  const openMobileHistoryModal = _react.useCallback.call(void 0, () => setIsMobileHistoryModalOpen(true), [])
  const closeMobileHistoryModal = _react.useCallback.call(void 0, () => setIsMobileHistoryModalOpen(false), [])
  const openDesktopHistoryModal = _react.useCallback.call(void 0, () => setIsDesktopHistoryModalOpen(true), [])
  const closeDesktopHistoryModal = _react.useCallback.call(void 0, () => setIsDesktopHistoryModalOpen(false), [])

  // Returns nothing, as in JS: the rename modal is closed before the rename
  // resolves, so its submit state never waits on it.
  const handleRoomRename = _react.useCallback.call(void 0, (name) => {
    closeRenameRoomModal()
    onRoomRename(name)
  }, [closeRenameRoomModal, onRoomRename])

  const handleRoomArchive = _react.useCallback.call(void 0, () => {
    closeArchiveRoomModal()
    onRoomArchive().then(onBack)
  }, [closeArchiveRoomModal, onRoomArchive, onBack])

  const moreMenuOptions = [
    {
      label: 'Rename meeting',
      onPick: openRenameRoomModal,
      iconSrc: 'assets/icons/video/edit-black.svg',
    },
    isRoomArchived
      ? {
          label: 'Unarchive meeting',
          onPick: onRoomUnarchive,
          iconSrc: 'assets/icons/video/retry-black.svg',
        }
      : {
          label: 'Archive meeting',
          onPick: openArchiveRoomModal,
          iconSrc: 'assets/icons/video/delete-black.svg',
        },
  ]

  const onlineStatusClassName = _classBuilder2.default.call(void 0, 
    "meeting-room--header--online-status",
    { active: activeParticipantsCount > 0 },
  )

  const activeParticipantsLabel = activeParticipantsCount > 0
    ? activeParticipantsCount === 1
      ? '1 participant on call'
      : `${activeParticipantsCount} participants on call`
    : 'No current call'

  return (
    _react2.default.createElement('div', { className: "meeting-room--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
      , _react2.default.createElement('div', { className: "meeting-room--header--mobile-back-btn", onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}} )
      , _react2.default.createElement('div', { className: "meeting-room--header--mobile-more-btn", onClick: openMobileMoreMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}} )
      , _react2.default.createElement('div', { className: "meeting-room--header--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
        , _react2.default.createElement('h3', { className: "meeting-room--header--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, roomName)
        , _react2.default.createElement('span', { className: onlineStatusClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, activeParticipantsLabel)
        , _react2.default.createElement(_LinkBar2.default, {
          link: roomLink,
          className: "meeting-room--header--link-bar",
          onShare: onRoomShare,
          onCopy: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
        )
      )
      , _react2.default.createElement('div', { className: "meeting-room--header--controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
        , _react2.default.createElement('div', { className: "meeting-room--header--btns-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
          , _react2.default.createElement('a', {
            onClick: gotoMeeting,
            className: "meeting--btn meeting-room--header--btn-primary" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}

            , _react2.default.createElement('img', { src: "/assets/icons/video/out-white.svg", alt: "->", __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} ), "Go to meeting"

          )
          , _react2.default.createElement('a', {
            onClick: openDesktopHistoryModal,
            className: "blmh-mobile-hide meeting--btn meeting--btn--secondary meeting-room--header--btn-secondary"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}

            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}, "View history" )
          )
          , _react2.default.createElement('a', {
            onClick: openMobileHistoryModal,
            className: "blmh-desktop-hide meeting--btn meeting--btn--secondary meeting-room--header--btn-secondary"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}

            , _react2.default.createElement('img', { src: "assets/icons/video/history-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}, "History")
          )
          , _react2.default.createElement(_DesktopMoreTooltip2.default, {
            openDesktopHistoryModal: openDesktopHistoryModal,
            onRoomRename: openRenameRoomModal,
            isRoomArchived: isRoomArchived,
            onRoomArchive: openArchiveRoomModal,
            onRoomUnarchive: onRoomUnarchive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}

            , _react2.default.createElement('div', { className: "meeting-room--header--desktop-more-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}} )
          )
        )
      )
      , _react2.default.createElement(_MenuPicker.MenuPicker, {
        title: "More...",
        isOpen: isMobileMoreMenuOpen,
        onClose: closeMobileMoreMenu,
        options: moreMenuOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
      )
      , _react2.default.createElement(_RenameRoomModal2.default, {
        roomName: roomName,
        isOpen: isRenameRoomModalOpen,
        onClose: closeRenameRoomModal,
        onProceed: handleRoomRename, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
      )
      , _react2.default.createElement(_ArchiveRoomModal2.default, {
        isOpen: isArchiveRoomModalOpen,
        onClose: closeArchiveRoomModal,
        onProceed: handleRoomArchive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}
      )
      ,  isDesktopHistoryModalOpen &&
        _react2.default.createElement(_Modal2.default, { onClose: closeDesktopHistoryModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}} )
      
      ,  isMobileHistoryModalOpen &&
        _react2.default.createElement(_Modal2.default, { isMobile: true, onClose: closeMobileHistoryModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}} )
      
    )
  )
}

exports. default = RoomBodyHeader
